<template>
    <div class="remove-tag-config">
        <div class="config-field">
            <label>Çıkarılacak Etiketler</label>
            <a-select
                v-model="localConfig.tagIds"
                mode="multiple"
                placeholder="Etiketler seçin"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option
                    v-for="tag in taskTags"
                    :key="tag._id"
                    :value="tag._id"
                >
                    {{ tag.name }}
                </a-select-option>
            </a-select>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "RemoveTagConfig",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: { tagIds: [] }
        };
    },
    computed: {
        ...mapState({
            tags: state => state.tag.tags.data || []
        }),
        taskTags() {
            return this.tags.filter(t => t.type === 'task');
        }
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        }
    }
};
</script>

<style lang="scss" scoped>
.remove-tag-config {
    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }
    }
}
</style>
